import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { GrantService } from '../../../services/grant.service';
import { FilterFieldConfig } from '../filter.component';
import { GetGrantsFilter, Grant } from '../../../models/grant';
import { ApplicationStatus } from '../../../enums/application-status';


@Injectable({
  providedIn: 'root'
})
export class ApplicationsFilterBuilder {
  private fields: FilterFieldConfig[] = [];

  constructor(private grantService: GrantService) {}


  status(): ApplicationsFilterBuilder {
    this.fields.push({
      name: 'status',
      label: 'Status prijave',
      type: 'select',
      multiple: false,
      options: [
        { label: 'Skica',                             value: ApplicationStatus.Draft },
        { label: 'Prijava predana',                   value: ApplicationStatus.Submitted },
        { label: 'Prijava vraćena na doradu',         value: ApplicationStatus.Returned },
        { label: 'Prijava ponovno predana',           value: ApplicationStatus.Resubmitted },
        { label: 'Ispunjeni formalni uvjeti',         value: ApplicationStatus.InCompliance },
        { label: 'Formalni uvjeti nisu ispunjeni',    value: ApplicationStatus.NonCompliance },
        { label: 'Pozitivna ocjena',                  value: ApplicationStatus.PositiveReview },
        { label: 'Negativna ocjena',                  value: ApplicationStatus.NegativeReview },
        { label: 'Prijava odobrena',                  value: ApplicationStatus.Approved },
        { label: 'Prijava odbijena',                  value: ApplicationStatus.Rejected },
      ],
      placeholder: 'Odaberite status',
    });
    return this;
  }

  years(fromYear: number, yearsCount: number = 100): ApplicationsFilterBuilder {
    const options = Array.from({ length: yearsCount }, (_, i) => ({
      label: (fromYear + i).toString(),
      value: fromYear + i
    }));

    this.fields.push({
      name: 'year',
      label: 'Godina',
      type: 'select',
      multiple: false,
      options,
      placeholder: 'Odaberite godinu',
      initialValue: fromYear
    });
    return this;
  }


  reset(): ApplicationsFilterBuilder {
    this.fields = [];
    return this;
  }

  build(): FilterFieldConfig[] {
    return this.fields;
  }
}